
const getDefaultState = () => ({
  isLoading: false,
  url: '',
  id: null,
});

export const state = () => getDefaultState();

const makeTrainingSummaryImage = item => ({
  url: item.url,
  id: item.id,
});

export const actions = {
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
  async GET_TRAINING_SUMMARY_IMAGE({ state, commit }, { type }) {
    try {
      if (state.isLoading) {
        return;
      }

      commit('SET_LOADING_TRAINING_SUMMARY_IMAGE_START');

      const response = await this.$axios.$get('/api/shareable-moments/training-summary/image', {
        params: {
          type,
        },
        hideToastr: true,
      });

      commit('SET_TRAINING_SUMMARY_IMAGE', {
        data: makeTrainingSummaryImage(response.data),
      });
      commit('SET_LOADING_TRAINING_SUMMARY_IMAGE_END');
    } catch (e) {
      commit('CLEAR_DATA');
      return Promise.reject(e);
    }
  },
};

export const mutations = {
  CLEAR_DATA(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TRAINING_SUMMARY_IMAGE(state, { data }) {
    state.url = data.url;
    state.id = data.id;
  },
  SET_LOADING_TRAINING_SUMMARY_IMAGE_START(state) {
    state.isLoading = true;
  },
  SET_LOADING_TRAINING_SUMMARY_IMAGE_END(state) {
    state.isLoading = false;
  },
};
